import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "directory-toolbar" }
const _hoisted_2 = {
  key: 0,
  class: "divider"
}
const _hoisted_3 = {
  key: 1,
  class: "bulk-container"
}
const _hoisted_4 = {
  key: 0,
  class: "divider"
}

import ActionButton from './ActionButton.vue'
import ActionMenu from './ActionMenu.vue'
import { Action, DirectoryItem } from './types'
import { usePrivileges } from './privileges'
import { toRefs } from 'vue'

type Props = {
  newActions: Action[]
  bulkActions: Action[]
  selectedItems: DirectoryItem[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DirectoryToolbar',
  props: {
    newActions: {},
    bulkActions: {},
    selectedItems: {}
  },
  emits: ["action"],
  setup(__props: any) {

const props = __props
const { newActions, bulkActions, selectedItems } = toRefs(props)



const privileges = usePrivileges()

const newAction = {
  actionName: 'new',
  labelKey: 'general__text__new',
  icon: 'IconPlusSquareSmall'
}

const settingAction: Action = {
  actionName: 'settings',
  labelKey: 'general__text__settings',
  icon: 'IconTool2'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(newActions).length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(ActionMenu, {
            actions: _unref(newActions),
            onAction: _cache[0] || (_cache[0] = (action) => _ctx.$emit('action', action.actionName, _unref(selectedItems)))
          }, {
            button: _withCtx(() => [
              _createVNode(ActionButton, {
                action: newAction,
                size: "small",
                "hover-background-color": "#3F46D6",
                "invert-on-hover": "",
                chevron: "",
                "show-text": ""
              })
            ]),
            _: 1
          }, 8, ["actions"]),
          (_unref(bulkActions).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(bulkActions).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bulkActions), (action) => {
            return (_openBlock(), _createBlock(ActionButton, {
              key: action.actionName,
              disabled: _unref(selectedItems).length === 0,
              action: action,
              onAction: (action) => _ctx.$emit('action', action.actionName, _unref(selectedItems))
            }, null, 8, ["disabled", "action", "onAction"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(privileges).isAdmin)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_unref(newActions).length || _unref(bulkActions).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true),
          _createVNode(ActionButton, {
            action: settingAction,
            onAction: _cache[1] || (_cache[1] = (action) => _ctx.$emit('action', action.actionName, []))
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})